"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridLeverageProcessor = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const GridTradingUtils_1 = require("./GridTradingUtils");
const trade_utils_lib_1 = require("trade_utils_lib");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const decimal_js_1 = __importDefault(require("decimal.js"));
const TextAndSliderSyncTool_1 = require("../CommonUtils/TextAndSliderSyncTool");
class GridLeverageProcessor {
    // 返回值为空数组 则是不支持,  undefined是正在请求中
    static useLeverageRates(base, quote, tradeAPI) {
        const [rates, setRates] = (0, react_1.useState)(undefined);
        (0, react_1.useEffect)(() => {
            setRates(undefined);
            const sub = tradeAPI.queryLeverageSupportedConfig().subscribe((resp) => {
                const key = `${base}_${quote}`;
                const data = resp[key];
                if (data) {
                    setRates(data["leverage_ratios"] || []);
                }
                else {
                    setRates([]);
                }
            }, (err) => {
                setRates([]);
            });
            return () => {
                sub && sub.unsubscribe();
            };
        }, [base, quote, tradeAPI]);
        return rates;
    }
    static useUserParams(earnCoin, earnCoinDisplay, trend, top, bottom, count, invest, investPercent, gridType, baseAvailable, quoteAvailable, triggerPrice, stopLostPrice, takeProfitPrice, currentPrice, symbol, market, tradeAPI, botType, leverageRate, investAction, openPriceLimit, updateSignal) {
        var _a;
        const isLeverage = (0, react_1.useMemo)(() => {
            return botType === TradeAPILib_1.ExchangeOrderType.gridLeverage || botType === TradeAPILib_1.ExchangeOrderType.gridLeverageShort;
        }, [botType]);
        const openPrice = (0, react_1.useMemo)(() => {
            return Number(triggerPrice) ? triggerPrice : currentPrice;
        }, [triggerPrice, currentPrice]);
        const [fee, feeError] = GridTradingUtils_1.GridTradingUtils.useFeeRate(symbol, tradeAPI, market, "maker");
        const profitPerGrid = GridTradingUtils_1.GridTradingUtils.useProfitPerGrid(gridType, top, bottom, count, fee);
        const calcuGridsMax = GridTradingUtils_1.GridTradingUtils.useRealMaxGridCount(top, bottom, gridType, fee, (_a = symbol.precision) !== null && _a !== void 0 ? _a : 0, 150);
        const minInvest = GridTradingUtils_1.GridTradingUtils.useMinInvest(botType, trend, earnCoin, gridType, top, bottom, count, symbol, market, tradeAPI, currentPrice, triggerPrice, `${leverageRate}`, fee, updateSignal);
        // 获取借贷的币种, 借贷币种的精度, 投资的币种的精度
        const [debtCoin, debtCoinDisplay, debtPrecision, earnPrecision] = (0, react_1.useMemo)(() => {
            let debt_coin = "";
            let debtCoinDisplay = "";
            let debt_precision = 0;
            const earn_precision = (earnCoin === symbol.base ? symbol.amount : symbol.precision) || 0;
            if (trend === "long") {
                // 看多投base, 抵押base, 借的是quote
                // 看多投quote, 借的是quote
                debt_coin = symbol.quote;
                debtCoinDisplay = symbol.quote;
                debt_precision = symbol.precision || 0;
            }
            else {
                // 看空投base,  借的是base
                // 看空投quote, 抵押quote, 借的是base
                debt_coin = symbol.base;
                debtCoinDisplay = symbol.baseDisplay;
                debt_precision = symbol.amount || 0;
            }
            return [debt_coin, debtCoinDisplay, debt_precision, earn_precision];
        }, [symbol.symbol, earnCoin, trend, leverageRate, botType]);
        const earnAvailable = (0, react_1.useMemo)(() => {
            return earnCoin === symbol.quote ? quoteAvailable : baseAvailable;
        }, [baseAvailable, quoteAvailable, symbol, earnCoin]);
        const [debtAvailable, totalAvailable] = (0, react_1.useMemo)(() => {
            let debtAvailble = "";
            let totalAvailable = "";
            // 为杠杆网格, 总投资额为本金加借贷的资金 earnCoin === debtCoin
            if (isLeverage) {
                debtAvailble = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(new trade_utils_lib_1.SafeDecimal(earnAvailable).mul(new trade_utils_lib_1.SafeDecimal(leverageRate - 1)), debtPrecision);
                totalAvailable = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(new trade_utils_lib_1.SafeDecimal(earnAvailable).add(new trade_utils_lib_1.SafeDecimal(debtAvailble)), earnPrecision);
            }
            else {
                // 为借贷网格, 总投资额为抵押金, 也就是本金 earnCoin !== debtCoin
                const curPrice = new trade_utils_lib_1.SafeDecimal(openPrice);
                if (debtCoin === symbol.base) {
                    if (curPrice.greaterThan(0)) {
                        const debtAvailbleDecimal = new trade_utils_lib_1.SafeDecimal(earnAvailable).div(curPrice).mul(new trade_utils_lib_1.SafeDecimal(leverageRate));
                        debtAvailble = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(debtAvailbleDecimal, debtPrecision);
                    }
                }
                else {
                    const debtAvailbleDecimal = new trade_utils_lib_1.SafeDecimal(earnAvailable).mul(curPrice).mul(new trade_utils_lib_1.SafeDecimal(leverageRate));
                    debtAvailble = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(debtAvailbleDecimal, debtPrecision);
                }
                totalAvailable = earnAvailable;
            }
            return [debtAvailble, totalAvailable];
        }, [earnAvailable, symbol.symbol, debtPrecision, earnPrecision, leverageRate, openPrice, isLeverage]);
        const [parseInvest, parseInvestPercent] = TextAndSliderSyncTool_1.TextAndSliderSyncTool.useGridInvestAndInvestPercent(investAction, invest, investPercent, totalAvailable, earnPrecision);
        const [earnInvest, debtInvest] = (0, react_1.useMemo)(() => {
            if (!parseInvest) {
                return ["", ""];
            }
            if (isLeverage) {
                const eInvest = new trade_utils_lib_1.SafeDecimal(parseInvest).div(new trade_utils_lib_1.SafeDecimal(leverageRate));
                const eInvestStr = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(eInvest, earnPrecision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
                const dInvest = new trade_utils_lib_1.SafeDecimal(parseInvest).sub(new trade_utils_lib_1.SafeDecimal(eInvestStr));
                const dInvestStr = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(dInvest, debtPrecision);
                return [eInvestStr, dInvestStr];
            }
            else {
                if (earnCoin === symbol.base && debtCoin === symbol.quote) {
                    const res = new trade_utils_lib_1.SafeDecimal(parseInvest).mul(new trade_utils_lib_1.SafeDecimal(openPrice)).mul(new trade_utils_lib_1.SafeDecimal(leverageRate));
                    const debtInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(res, debtPrecision);
                    return [parseInvest, debtInvest];
                }
                else if (earnCoin === symbol.quote && debtCoin === symbol.base) {
                    const res = new trade_utils_lib_1.SafeDecimal(parseInvest).div(new trade_utils_lib_1.SafeDecimal(openPrice)).mul(new trade_utils_lib_1.SafeDecimal(leverageRate));
                    const debtInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(res, debtPrecision);
                    return [parseInvest, debtInvest];
                }
                console.error("借贷只能抵押一个币, 借另一个币");
                return [parseInvest, ""];
            }
        }, [parseInvest, leverageRate, earnPrecision, debtPrecision, earnCoin, debtCoin, isLeverage, openPrice, symbol]);
        const investState = (0, react_1.useMemo)(() => {
            const state = {
                state: "normal",
                min: minInvest,
                max: totalAvailable,
            };
            if (parseInvest) {
                if (new trade_utils_lib_1.SafeDecimal(parseInvest).greaterThan(new trade_utils_lib_1.SafeDecimal(totalAvailable))) {
                    state.state = "large";
                }
                else if (new trade_utils_lib_1.SafeDecimal(parseInvest).lessThan(new trade_utils_lib_1.SafeDecimal(minInvest))) {
                    state.state = "small";
                }
            }
            return state;
        }, [parseInvest, minInvest, totalAvailable]);
        // 获取借贷币种资金池总资金
        const [debtRemoteAvailable, setDebtRemoteAvailable] = (0, react_1.useState)("");
        (0, react_1.useEffect)(() => {
            setDebtRemoteAvailable("");
            const sub = (0, rxjs_1.timer)(0, 5000)
                .pipe((0, operators_1.flatMap)(() => {
                return tradeAPI.queryDeptAvaliable(debtCoin).pipe((0, operators_1.catchError)((error) => {
                    return (0, rxjs_1.of)(undefined);
                }));
            }))
                .subscribe((data) => {
                if (data) {
                    const amount = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(data.amount || "");
                    setDebtRemoteAvailable(amount);
                }
            }, (error) => {
                setDebtRemoteAvailable("");
            });
            return () => {
                sub && sub.unsubscribe();
            };
        }, [debtCoin, tradeAPI]);
        // 获取借贷日利率和风险率
        const [debtRate, setDebtRate] = (0, react_1.useState)("");
        const [liquidationBar, setLiquidationBar] = (0, react_1.useState)("");
        (0, react_1.useEffect)(() => {
            const sub = (0, trade_utils_lib_1.requestWithRetry)(() => {
                return tradeAPI.queryLeverageTradeInfo(symbol.base, symbol.quote);
            }).subscribe((data) => {
                const result = debtCoin === symbol.base ? data.base_debt_rate : data.quote_debt_rate;
                const rate = new trade_utils_lib_1.SafeDecimal(result || "0").mul(100).toSignificantDigits(2, decimal_js_1.default.ROUND_CEIL).toString();
                const ratePercent = rate + `%`;
                setDebtRate(result ? ratePercent : "--");
                const liquidation_bar = data.liquidation_bar ? `${data.liquidation_bar}` : "1";
                setLiquidationBar(liquidation_bar);
            }, (error) => {
                setDebtRate("");
                setLiquidationBar("1");
            });
            return () => {
                return sub && sub.unsubscribe();
            };
        }, [tradeAPI, symbol, debtCoin]);
        const liquidationPrice = (0, react_1.useMemo)(() => {
            let gridBaseInvest = "0"; // 运行网格的base资金
            let gridQuoteInvest = "0"; // 运行网格的quote资金
            let depositBase = "0"; // 不参与交易的base保证金
            let depositQuote = "0"; // 不参与交易的quote保证金
            let loanAmount = "0"; // 借到的资金 看多借quote, 看空借base
            if (isLeverage) {
                if (earnCoin === symbol.base) {
                    gridBaseInvest = parseInvest;
                }
                else {
                    gridQuoteInvest = parseInvest;
                }
                loanAmount = new trade_utils_lib_1.SafeDecimal(parseInvest).sub(new trade_utils_lib_1.SafeDecimal(parseInvest).div(new trade_utils_lib_1.SafeDecimal(leverageRate))).toString();
            }
            else {
                // 借贷网格
                if (earnCoin === symbol.base) {
                    // 抵押base借quote
                    depositBase = parseInvest;
                    gridQuoteInvest = new trade_utils_lib_1.SafeDecimal(parseInvest)
                        .mul(new trade_utils_lib_1.SafeDecimal(openPrice))
                        .mul(new trade_utils_lib_1.SafeDecimal(leverageRate))
                        .toString();
                    loanAmount = gridQuoteInvest;
                }
                else {
                    // 抵押quote借base
                    depositQuote = parseInvest;
                    gridBaseInvest = new trade_utils_lib_1.SafeDecimal(parseInvest)
                        .div(new trade_utils_lib_1.SafeDecimal(openPrice))
                        .mul(new trade_utils_lib_1.SafeDecimal(leverageRate))
                        .toString();
                    loanAmount = gridBaseInvest;
                }
            }
            const liquidationBarNum = new trade_utils_lib_1.SafeDecimal(liquidationBar).toNumber() || 1;
            const perVolume = GridTradingUtils_1.GridTradingUtils.getPerGridValume(top, bottom, count, gridBaseInvest, gridQuoteInvest, openPrice, gridType, trend);
            const result = GridTradingUtils_1.GridTradingUtils.calculateLiquidationPrice(top, bottom, count, liquidationBarNum, trend, `${perVolume}`, loanAmount, gridType, symbol, depositBase, depositQuote);
            return result;
        }, [top, bottom, count, liquidationBar, trend, gridType, botType, parseInvest, earnCoin, leverageRate, openPrice]);
        const emptyErrors = (0, react_1.useMemo)(() => {
            const emptys = GridTradingUtils_1.GridTradingUtils.checkRequiredParamsEmpty(top, bottom, count);
            if (!Number(parseInvest)) {
                if (isLeverage) {
                    emptys.push("trade_leverage_invest");
                }
                else {
                    emptys.push("trade_pledge_invest");
                }
            }
            return emptys;
        }, [top, bottom, count, parseInvest, isLeverage]);
        const result = {
            botType,
            top,
            bottom,
            count,
            invest: parseInvest,
            investPercent: parseInvestPercent,
            gridType,
            baseAvailable,
            quoteAvailable,
            earnCoin,
            trend,
            useAllCoins: false,
            triggerPrice,
            stopLostPrice,
            takeProfitPrice,
            currentPrice,
            symbol,
            fee,
            calculateFee: fee,
            emptyErrors,
            investState,
            minInvest,
            profitPerGrid,
            totalAvailable,
            debt_rate: debtRate,
            debtCoin,
            debtCoinDisplay,
            liquidation_bar: liquidationBar,
            earnAvailable,
            debtAvailable,
            debtRemoteAvailable,
            liquidation_price: liquidationPrice,
            leverageRate,
            earnPrecision,
            debtPrecision,
            earnInvest,
            debtInvest,
            openPriceLimit,
            earnCoinDisplay,
            feeError,
            realMaxGrids: calcuGridsMax,
        };
        return result;
    }
    static getCreateOrderRequest(params, $st) {
        const baseRequest = GridTradingUtils_1.GridTradingUtils.checkCommonParamsByLocal(params, $st);
        baseRequest.leverage = new trade_utils_lib_1.SafeDecimal(params.leverageRate).toString();
        if (params.earnCoin === params.symbol.base) {
            baseRequest.base_total_investment = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(params.earnInvest, params.symbol.amount);
            baseRequest.quote_total_investment = "0";
        }
        else {
            baseRequest.base_total_investment = "0";
            baseRequest.quote_total_investment = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(params.earnInvest, params.symbol.precision);
        }
        // 开单价格在格子区间外, 并且在赔钱的方向, 不让用户开单
        //赔钱的方向:(开多时, 开单价格在格子区间的最高价往上 `tip: 也就是跌下来才进入格子, 但是跌下来已经赔钱了, 甚至是爆仓`)
        //赔钱的方向:(开空时, 开单价格在格子区间的最低价往下 `tip: 也就是涨下来才进入格子, 但是涨上去已经赔钱了, 甚至是爆仓`)
        const openPrice = new trade_utils_lib_1.SafeDecimal(Number(params.triggerPrice) || Number(params.currentPrice));
        if (params.trend === "long" && openPrice.greaterThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(params.top))) {
            if (Number(params.triggerPrice)) {
                throw $st("grid_error_triggle_price_not_in_range");
            }
            throw $st("grid_error_current_price_not_in_range");
        }
        else if (params.trend === "short" && openPrice.lessThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(params.bottom))) {
            if (Number(params.triggerPrice)) {
                throw $st("grid_error_triggle_price_not_in_range");
            }
            throw $st("grid_error_current_price_not_in_range");
        }
        return baseRequest;
    }
}
exports.GridLeverageProcessor = GridLeverageProcessor;
